import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { useInsertName } from "./utils/helpers";

function SectionAnmelden() {
  const { slug } = useParams(); // useParams Hook verwenden, um den slug aus der URL zu holen
  const name = useInsertName(); // Hol dir den Namen aus dem Kontext

  return (
    <div>
      {/* Die oben definierte Section */}
      <section className="bg-gray-900 py-20 sm:py-16 md:py-20">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-center">
            {/* Linke Spalte: Titel */}
            <div className="text-center md:text-left">
              <h1 className="text-2xl  sm:text-5xl md:text-4xl font-bold text-white mb-4">
                Überzeugt {name}<span className="text-orange-50">?</span> <br />Na dann <span className="text-teal-300">los...</span>
              </h1>
            </div>

            {/* Rechte Spalte: Anmeldebutton */}
           {/* Rechte Spalte: Anmeldebutton */}
{/* Rechte Spalte: Anmeldebutton */}
<div className="flex flex-col md:flex-row justify-center md:justify-end items-center space-y-4 md:space-y-0 md:space-x-4 mt-4 md:mt-0">
  <Link
    to={`/anmeldung/${slug}`}
    className="w-full md:w-auto text-center bg-pink-500 text-white px-8 py-3 rounded-full font-semibold hover:bg-teal-300 transition duration-300"
  >
    Anmelden
  </Link>
  <Link
    to={`/anmeldung/${slug}`}
    className="w-full md:w-auto text-center bg-pink-500 text-white px-8 py-3 rounded-full font-semibold hover:bg-teal-300 transition duration-300"
  >
    Noch Fragen
  </Link>
</div>
            
          </div>
        </div>
      </section>
      
      {/* Weitere Sections oder Inhalte hier */}
    </div>
  );
}

export default SectionAnmelden;